import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import Typography from "../../Typography";

export default function TooltipBase({ texto, item, posicao = "lado" }) {
    const [show, setShow] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const spanRef = useRef(null);

    const elementos = {
        lado: "translate-y-[-50%] left-full top-1/2",
        baixo: "translate-y-6 left-1/2 top-full"
    };

    const handleMouseEnter = () => {
        setShow(true);
        const rect = spanRef.current.getBoundingClientRect();
        setCoords({
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
            width: rect.width,
            height: rect.height
        });
    };

    const handleMouseLeave = () => setShow(false);

    // Calcula a posição do tooltip fora do fluxo normal
    const getTooltipStyle = () => {
        if (posicao === "lado") {
            return {
                top: coords.top + coords.height / 2,
                left: coords.left + coords.width -14, // 8px de margem
                transform: "translateY(-50%)"
            };
        }
        if (posicao === "baixo") {
            return {
                top: coords.top + coords.height -14,
                left: coords.left + coords.width / 2,
                transform: "translateX(-50%)"
            };
        }
        return {};
    };

    return (
        <>
            <span
                ref={spanRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="cursor-pointer"
            >
                {item}
            </span>
            {show && ReactDOM.createPortal(
                <div
                    className={`absolute flex z-50 pointer-events-none`}
                    style={{
                        position: "absolute",
                        ...getTooltipStyle()
                    }}
                >
                    <div className={`px-3 py-2 bg-neutras-black rounded shadow flex-col justify-start items-start gap-2 inline-flex max-w-84
                        m-8 z-20 right-0`}>
                        <Typography component="contrast">
                            {texto}
                        </Typography>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
}